import { Form, Input ,InputNumber, DatePicker} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import i18next from 'i18next';
import { ChangeEventHandler, useState } from 'react';
import dayjs from 'dayjs';

const toDayjs = (val: any) => {
  if (val === null || val === undefined || val === '') return null;
  if (dayjs.isDayjs(val)) return val.isValid() ? val : null;
  if (val instanceof Date) {
    const d = dayjs(val);
    return d.isValid() ? d : null;
  }
  if (typeof val === 'object' && 'format' in val && typeof val.format === 'function') {
    const d = dayjs(val.format('YYYY-MM-DD'));
    return d.isValid() ? d : null;
  }
  if (typeof val === 'string') {
    let d = dayjs(val);
    if (!d.isValid()) {
      const m = val.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (m) d = dayjs(`${m[3]}-${m[2]}-${m[1]}`);
    }
    return d.isValid() ? d : null;
  }
  const d = dayjs(val);
  return d.isValid() ? d : null;
};

//{/[0-9]{9}$/gmiy}
const InputForm = (props: { value?: any, label?: string, name?: string, error?: string, taille?: number, type: string, width?: number, widthl?: number, placeholder?: string, notRequired?: true, title?: string, maxLength?: number, minLength?: number, icon?: any, defaultValue?: any, disabled?: boolean, onChange?: ChangeEventHandler,onBlur?: ChangeEventHandler, min?: number, max?: any, row?: number, RegExp?: RegExp, MessExp?: string, search?: true, onSearch?: any, autoFocus?: true,money?:boolean,pourcent?:boolean,noupercase?:true
  rules?: any[], dependencies?: string[] // <--
}) => {
  let notR = props.notRequired ? false : true;
  //let RegExp: RegExp = props.RegExp ? props.RegExp : props.pourcent ? /[0-9]{100}$/g : /$/;
//  let RegExp: RegExp = props.RegExp ? props.RegExp:props.pourcent?/[0-9]{100}$/gmiy: (/$/);

  let MessExp:string = props.MessExp ?props.MessExp:props.pourcent?'pas plus de 100 %': '';
  let RegExp: RegExp = props.RegExp? props.RegExp: props.pourcent? /^(100|[1-9]?\d)$/ : /$/;;
   
  const finalRules = [
    { required: notR, message: '' },
    { pattern: RegExp, message: MessExp },
    ...(props.rules || []) // <-- AJOUT ICI : N'affecte pas si props.rules est vide
  ];


  const isDate = props.type === 'date';

  return (
      <Form.Item
        initialValue={props.defaultValue}
        labelCol={{ span: props.width, offset:props.widthl,style: {whiteSpace: 'pre-wrap'} }}
        label={props.label} className='bordure'
         name={props.name}

        dependencies={props.dependencies} // <-- AJOUT ICI
       rules={finalRules}
        // rules={[{ required: notR, message: '' },{ pattern: RegExp, message: MessExp }]}
        {...(isDate ? {
          getValueProps: (value: any) => ({ value: toDayjs(value) ?? null }),
          getValueFromEvent: (date: any) => (date ? date.format('YYYY-MM-DD') : ''),
        } : {})}
      >
        {props.type == "TextArea" ?
           <TextArea onInput={e => (e.target as HTMLInputElement).value =(e.target as HTMLInputElement).value.toUpperCase()} autoFocus={props.autoFocus} disabled={props.disabled} placeholder={props.placeholder} rows={props.row ? props.row : 2} style={{ width: '100%' }} />
            :
            props.search ?
            <Input.Search autoFocus={props.autoFocus} onSearch={props.onSearch} max={props.max} value={props.value} step="0.01" lang={i18next.language} min={props.min} style={{ width: props.taille || '100%' }} onChange={props.onChange} disabled={props.disabled} defaultValue={props.defaultValue} addonBefore={props.icon} maxLength={props.maxLength} minLength={props.minLength} type={props.type} placeholder={props.placeholder} />
            :
            props.pourcent?
            <InputNumber
            min={0}
            max={100}
            formatter={(value) => `${value}%`}
            value={props.value}
            onChange={props.onChange as ((value: any) => void) | undefined}
            parser={(value) => value!.replace('%', '')}
            style={{ width: props.taille || '100%' }} disabled={props.disabled} defaultValue={props.defaultValue} addonBefore={props.icon} maxLength={props.maxLength} minLength={props.minLength} placeholder={props.placeholder} 
          />:
            props.money ?
//             <InputNumber
//   autoFocus={props.autoFocus}
//   value={props.value}
//   onChange={props.onChange as ((value: number | null) => void) | undefined}
//   formatter={(value) => {
//     if (!value) return '';
//     const [intPart, decimalPart] = value.toString().split('.');
//     const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
//     return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
//   }}
//   parser={(value) => {
//     if (!value) return 0;
//     const cleaned = value.replace(/,/g, '');
//    // alert(cleaned);
//     return parseFloat(cleaned);
//   }}
//   max={props.max}
//   min={props.min}
//   step={0.01}
//   lang={i18next.language}
//   style={{ width: props.taille, opacity: 1 }}
//   disabled={props.disabled}
//   defaultValue={props.defaultValue}
//   addonBefore={props.icon}
//   maxLength={props.maxLength}
//   minLength={props.minLength}
//   placeholder={props.placeholder}
// />

            <InputNumber
            // ^([0-9]|([1-9][0-9])|100)$
            autoFocus={props.autoFocus}
            value={props.value}
            onChange={props.onChange as ((value: any) => void) | undefined}
            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
            parser={(value) => value!.replace(/\$\s?|( *)/g, '')}
            max={props.max} step="1" lang={i18next.language} min={props.min !== undefined ? Math.max(0, props.min) : 0} style={{ width: props.taille || '100%',opacity:2}} disabled={props.disabled} defaultValue={props.defaultValue} addonBefore={props.icon} maxLength={props.maxLength} minLength={props.minLength} placeholder={props.placeholder}  
            /> 
            :
            props.type == "date" ?
            <DatePicker
              format="DD/MM/YYYY"
              placeholder={props.placeholder || "jj/mm/aaaa"}
              onChange={(date: any) => {
                const val = date ? date.format('YYYY-MM-DD') : '';
                const e = { target: { value: val } } as any;
                if (props.onChange) props.onChange(e);
                if (props.onBlur) props.onBlur(e);
              }}
              onBlur={(e: any) => {
                const raw = e?.target?.value;
                const d = toDayjs(raw);
                const val = d ? d.format('YYYY-MM-DD') : '';
                if (props.onBlur) props.onBlur({ target: { value: val } } as any);
              }}
              style={{ width: props.taille || '100%' }}
              disabled={props.disabled}
            />
            :
            props.type == "label" ?
            <Input onChange={props.onChange} onBlur={props.onBlur} autoFocus={props.autoFocus} max={props.max} step="0.01" lang={i18next.language} min={props.min} style={{ width: props.taille || '100%', backgroundColor: '#f5f5f5' }} disabled={true} defaultValue={props.defaultValue} addonBefore={props.icon} maxLength={props.maxLength} minLength={props.minLength} type="text" placeholder={props.placeholder} readOnly />
            :
            <Input  value={props.value} onChange={props.onChange}  
             onBlur={props.onBlur}
              onInput={e => (e.target as HTMLInputElement).value = props.noupercase?(e.target as HTMLInputElement).value:(e.target as HTMLInputElement).value.toUpperCase()} 
             autoFocus={props.autoFocus}  max={props.max} step="0.01" lang={i18next.language} min={props.min} style={{ width: props.taille || '100%' }} disabled={props.disabled} defaultValue={props.defaultValue} addonBefore={props.icon} maxLength={props.maxLength} minLength={props.minLength} type={props.type} placeholder={props.placeholder} />
        }
      </Form.Item>
  );

}
export default InputForm;